<template>
  <div class="detail-box" v-if="detailInfo">
    <!-- 产品轮播图 -->
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="(item,index) in detailInfo.info.gallery" :key="index">
        <!-- <img :src="item" class="swiper-img" alt="" srcset=""> -->
        <van-image width="100%" :src="item" />

      </van-swipe-item>
    </van-swipe>
    <!-- 商品名称 -->
    <div class="detail-name">{{detailInfo.info.name}}</div>
    <!-- 价格 -->
    <div class="price-box">
      <div class="old-price">原价：{{detailInfo.info.counterPrice}}</div>
      <div class="new-price">现价：{{detailInfo.info.retailPrice}}</div>

    </div>
    <!-- tag -->
    <div class="detail-name">
      <div class="detail-tag">{{detailInfo.brand.name}} </div>
    </div>
    <!-- 规格 -->
    <div class="add-cart" @click="show = true">
      <!-- <div v-if="specificationList.length ==1">
        <div class="specifications" v-for="(item,x) in specificationList" :key="x">
          <div class="info-item" v-for="(info,idx) in item.valueList" :key="idx">{{info.value}}</div>
        </div>
      </div> -->
      <div v-if="isFirst" class="select-duct">请选择数量规格</div>

      <div v-else class="select-duct">
        <div v-for="(item,x) in specificationList" :key="x">
          <span style="font-size:1.4rem">{{item.name}}:</span>
          <span v-for="(info,idx) in item.valueList" class="data-item" :key="idx">{{info.selected ? info.value: ""}} </span>
        </div>
      </div>
      <van-icon class="next" name="arrow" />

    </div>
    <div class="comment-title" v-if="detailInfo.comment.data.length != 0">
      <div class="c-title-text"> <img class="pinglun" src="../../assets/index/pinglun_icon.png" alt="" srcset=""> 评论</div>
      <!-- <van-icon class="input-prew" @click="navCommentPost" name="edit" /> -->
      <div class="insert-text" @click="navCommentPost">
        <!-- <img class="input-icon" src="../../assets/index/input_icon.png" alt="" srcset=""> -->
        查看全部评论（{{detailInfo.comment.count}}）
      </div>
    </div>

    <div class="item-box" v-if="detailInfo.comment.data.length != 0">
      <div class="line"></div>
      <van-row class="list">
        <div class="comment-item" v-for="(item,index) in detailInfo.comment.data" :key="index">
          <div class="comment-item-top">
            <div class="comment-item-name">
              <img :src="item.avatar" alt="">
              <div class="item-name">{{item.nickname}}</div>

            </div>
            <div class="comment-item-tiem">{{item.addTime}}</div>
          </div>
          <div class="comment-item-content" v-if="item.content">{{item.content}}</div>
          <van-grid :column-num="4" :gutter="5">
            <van-grid-item v-for="(img,idx) in item.picList" :key="idx" @click="showImgs(item.picList,idx)" :icon="img" text="" />
          </van-grid>
        </div>
      </van-row>
      <!-- <div v-else class="no-message">暂无评价</div> -->
    </div>
    <!-- <div class="more" @click="onLoad" v-if="!finished && detailInfo.comment.count != 0">查看更多</div> -->
    <!-- 商品参数 -->
    <div class="commodity-parameter">
      <div class="commodity-title">商品参数</div>
      <div class="size" v-for="item in  detailInfo.attribute" :key="item.attribute">
        <div class="size-text">{{item.attribute}}</div>
        <div class="size-value">{{item.value}}</div>

      </div>
      <div class="com-info" v-html="detailInfo.info.detail"></div>
      <van-divider class="divider">
        常见问题
      </van-divider>
      <div class="quest-box">
        <div v-for="(questionItem,m) in detailInfo.issue" :key="m">
          <div class="quest-bt" v-html="questionItem.question"></div>
          <div class="quest-text" v-html="questionItem.answer"></div>

        </div>
      </div>

      <van-divider class="divider">
        大家都在看
      </van-divider>

      <div class="item-box">
        <van-row class="list">
          <itemInfo @navDetail="navToDetail(itemInfo.id)" v-for="(itemInfo,index) in goodsRelatedList" :key="index" :itemInfo="itemInfo"></itemInfo>

        </van-row>
      </div>

    </div>
    <van-popup v-model="show" position="bottom">
      <van-card title="" :thumb="detailInfo.info.picUrl">
        <template #desc>
          <div class="popup-box">
            <div class="select-data">价格：￥{{selectProductNum}}</div>
            <div class="select-data">已选择： <div v-for="(item,x) in specificationList" :key="x">
                <div v-for="(info,idx) in item.valueList" class="data-item" :key="idx">{{info.selected ? info.value: ""}} </div>
              </div>
            </div>
            <van-icon class="close-popup" @click="show=false" name="cross" />
          </div>

        </template>
      </van-card>
      <!-- <div class="select-name">热带水果</div> -->
      <div class="select-specifications" v-for="(item,x) in specificationList" :key="x">
        <div style="font-size:1.4rem">{{item.name}}</div>
        <div v-for="(info,idx) in item.valueList" @click="selectSpecifications(item,info)" :key="idx" :class="info.selected ? 'selected-item':'select-item'">{{info.value}}</div>
      </div>
      <div class="select-num">数量</div>
      <van-stepper v-model="addData.number" />

    </van-popup>
    <van-goods-action style="z-index:2200">
      <van-goods-action-icon icon="star" @click="collectionEvent" :text="collection ? '已收藏':'收藏'" :class="collection ? 'select_icon':''" />
      <van-goods-action-icon icon="cart-o" @click="navToCar" :info="goodsCount" text="购物车" />
      <van-goods-action-button type="warning" @click="setAddCart" text="加入购物车" />
      <van-goods-action-button type="danger" @click="nowToBuy" text="立即购买" />
    </van-goods-action>
  </div>

</template>

<script>
import {
  typeDetail,
  goodsRelated,
  addCart,
  cartFastadd,
  collectAddordelete,
  cartGoodscount,
} from "@/api/index";
import itemInfo from "@/components/itemInfo";
import { Dialog, Toast, ImagePreview } from "vant";

export default {
  name: "detail",
  components: {
    itemInfo,
    ImagePreview,
  },
  inject: ["reload"],
  data() {
    return {
      isFirst: true,
      isLogin: false,
      collection: false,
      detailInfo: null,
      finished: false,
      specificationList: [],
      goodsRelatedList: [],
      show: false,
      goodsCount: "", //购物车商品数量
      selectProductNum: 0,
      addData: {
        goodsId: 1181066, //商品id
        number: 1, //商品数量
        productId: 522, //商品销售id
      },
    };
  },
  created() {
    this.getDetailInfo();
    this.getCount();
    console.log("是否有登录啊嗷嗷");
    console.log(this.$store.state.base.userInfo);
    if (this.$store.state.base.userInfo != null) {
      this.isLogin = true;
    }
  },

  methods: {
    navCommentPost() {
      //查看全部评论
      // this.$router.push({
      //   path: "/type/allComment",
      //   query: {
      //     comment: JSON.stringify(this.detailInfo.comment)
      //   }
      // });
      this.$router.push({
        path: "/allComment",
        query: {
          comment: this.detailInfo.info.id,
        },
      });
    },
    getCount() {
      console.log(this.$store.state.base.userInfo);
      if (this.$store.state.base.userInfo == null) {
        return;
      }
      cartGoodscount().then((res) => {
        console.log(res);
        if (res.data.errno == 0) {
          this.goodsCount = res.data.data;
        } else {
          Dialog.alert({
            title: "提示",
            message: res.data.errmsg,
          });
        }
      });
    },
    collectionEvent() {
      let data = {
        type: 0, //type为0
        valueId: this.detailInfo.info.id, //商品id
      };
      if (!this.isLogin) {
        // Toast("请先登录");
        this.$router.push("/login");

        return;
      }
      console.log(this.detailInfo);
      this.collection = !this.collection;
      collectAddordelete(data).then((res) => {
        if (res.data.errno == 0) {
          if (res.data.data.type == "add") {
            Toast("收藏成功");
          } else {
            Toast("已取消收藏");
          }
        } else {
          Dialog.alert({
            title: "提示",
            message: res.data.errmsg,
          });
        }
      });
    },
    getDetailInfo() {
      typeDetail(this.$route.query.id).then((res) => {
        if (res.data.errno == 0) {
          this.detailInfo = res.data.data;
          res.data.data.userHasCollect == 1
            ? (this.collection = true)
            : (this.collection = false);
          this.specificationList = res.data.data.specificationList;
          console.log(res);

          this.specificationList.forEach((element) => {
            element.selected = false;

            element.valueList.forEach((item) => {
              item.selected = false;
            });
          });
          this.specificationList.forEach((item) => {
            item.selected = true;
            item.valueList[0].selected = true;
          });
          this.selectProductNum = res.data.data.productList[0].price;
          console.log(this.specificationList);
        } else {
          Dialog.alert({
            title: "提示",
            message: res.data.errmsg,
          });
        }
      });
      goodsRelated(this.$route.query.id).then((res) => {
        if (res.data.errno == 0) {
          this.goodsRelatedList = res.data.data.goodsList;
        } else {
          Dialog.alert({
            title: "提示",
            message: res.data.errmsg,
          });
        }
      });
    },
    selectSpecifications(far, child) {
      //选择产品规格
      this.specificationList.forEach((item) => {
        if (far.name == item.name) {
          item.selected = true;

          item.valueList.forEach((value) => {
            value.selected = false;

            if (value.id == child.id) {
              value.selected = true;
              // value = Object.assign({}, value, { selected: !value.selected });
              // this.$set(this.specificationList[i].valueList, idx, value);
            }
          });
        }
      });
      this.specificationList = JSON.parse(
        JSON.stringify(this.specificationList)
      );
      //根据选中的规格，判断是否有对应的sku信息
      let checkedProductArray = this.getCheckedProductItem(
        this.getCheckedSpecKey()
      );

      if (checkedProductArray.length != 0) {
        this.selectProductNum = checkedProductArray[0].price;
      }
    },
    isCheckedAllSpec() {
      //判断规格是否选择完整
      console.log(this.specificationList);
      for (const iterator of this.specificationList) {
        if (!iterator.selected) {
          return true;
        }
      }
      return false;
    },
    // 获取选中的产品（根据规格）
    getCheckedProductItem(key) {
      return this.detailInfo.productList.filter(function (v) {
        if (v.specifications.toString() == key.toString()) {
          return true;
        } else {
          return false;
        }
      });
    },
    //获取选中的规格信息
    getCheckedSpecValue() {
      let checkedValues = [];
      let _specificationList = this.specificationList;
      for (let i = 0; i < _specificationList.length; i++) {
        let _checkedObj = {
          name: _specificationList[i].name,
          valueId: 0,
          valueText: "",
        };
        for (let j = 0; j < _specificationList[i].valueList.length; j++) {
          if (_specificationList[i].valueList[j].selected) {
            _checkedObj.valueId = _specificationList[i].valueList[j].id;
            _checkedObj.valueText = _specificationList[i].valueList[j].value;
          }
        }
        checkedValues.push(_checkedObj);
      }

      return checkedValues;
    },

    getCheckedSpecKey() {
      let checkedValue = this.getCheckedSpecValue().map(function (v) {
        console.log(v);
        return v.valueText;
      });
      console.log(checkedValue);
      return checkedValue;
    },

    setAddCart() {
      //加入购物车
      if (!this.show) {
        this.show = true;
      } else {
        if (!this.isLogin) {
          // Toast("请先登录");
          this.$router.push("/login");

          return;
        }
        console.log("加入购物车操作  并且 show = false");
        if (this.isCheckedAllSpec()) {
          Dialog.alert({
            title: "提示",
            message: "请选择完整规格",
          }).then(() => {
            // on close
          });
          return;
        }
        //根据选中的规格，判断是否有对应的sku信息
        let checkedProductArray = this.getCheckedProductItem(
          this.getCheckedSpecKey()
        );
        console.log(checkedProductArray);
        if (!checkedProductArray || checkedProductArray.length <= 0) {
          //找不到对应的product信息，提示没有库存

          Dialog.alert({
            title: "提示",
            message: "没有库存",
          }).then(() => {
            return false;
            // on close
          });
        }

        let checkedProduct = checkedProductArray[0];
        console.log(checkedProductArray);
        if (checkedProduct.number <= 0) {
          Dialog.alert({
            title: "提示",
            message: "没有库存",
          }).then(() => {
            return false;
            // on close
          });
          return false;
        }
        this.addData.goodsId = this.detailInfo.info.id;
        this.addData.productId = checkedProduct.id;

        addCart(this.addData).then((res) => {
          if (res.data.errno == 0) {
            this.show = false;
            this.getCount();
            Toast.success("成功加入购物车");
            this.isFirst = false;
          } else if (res.data.errno == 501) {
            Dialog.alert({
              title: "提示",
              message: res.data.errmsg,
            }).then(() => {
              // on close
              localStorage.clear();
              sessionStorage.clear();
              this.$store.commit("SET_USERINFO", null);
              this.$router.push("/login");
            });
          }
        });
      }
    },
    nowToBuy() {
      //立即购买
      if (!this.show) {
        this.show = true;
      } else {
        if (!this.isLogin) {
          // Toast("请先登录");
          console.log("??????登录中能够爱哭的饭卡上");
          this.$router.push("/login");

          return;
        }
        console.log("立即购买操作  并且 show = false");
        if (this.isCheckedAllSpec()) {
          Dialog.alert({
            title: "提示",
            message: "请选择完整规格",
          }).then(() => {
            // on close
          });
          return;
        }
        //根据选中的规格，判断是否有对应的sku信息
        let checkedProductArray = this.getCheckedProductItem(
          this.getCheckedSpecKey()
        );
        if (!checkedProductArray || checkedProductArray.length <= 0) {
          //找不到对应的product信息，提示没有库存

          Dialog.alert({
            title: "提示",
            message: "没有库存",
          }).then(() => {
            return false;
            // on close
          });
        }

        let checkedProduct = checkedProductArray[0];
        if (checkedProduct.number <= 0) {
          Dialog.alert({
            title: "提示",
            message: "没有库存",
          }).then(() => {
            return false;
            // on close
          });
          return false;
        }
        sessionStorage.removeItem("couponId");
        this.addData.goodsId = this.detailInfo.info.id;
        this.addData.productId = checkedProduct.id;
        cartFastadd(this.addData).then((res) => {
          if (res.data.errno == 0) {
            this.$router.push({
              path: "/order",
              query: {
                cartId: res.data.data,
              },
            });
            sessionStorage.setItem("cartId", res.data.data);
            // sessionStorage.setItem('grouponRulesId', checkedGroupon.id);

            // sessionStorage.setItem('grouponLinkId', );
          } else if (res.data.errno == 501) {
            Dialog.alert({
              title: "提示",
              message: res.data.errmsg,
            }).then(() => {
              // on close
              localStorage.clear();
              sessionStorage.clear();
              this.$store.commit("SET_USERINFO", null);
              this.$router.push("/login");
            });
          }
        });
      }
    },
    navToCar() {
      // this.$router.go(-1);
      this.$router.push("/shopCar");
      sessionStorage.setItem("selectIdx", 3);
    },
    showImgs(list, idx) {
      ImagePreview({
        images: list,
        startPosition: idx,
        onClose() {
          // do something
        },
      });
    },
    navToDetail(id) {
      this.$router.push({
        path: "/type/detail",
        query: {
          id: id,
        },
      });
      this.reload();
    },
  },
  computed: {
    detailGoback() {
      return this.$store.state.base.detailGoback;
    },
  },
  beforeRouteLeave(to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    console.log(to);
    console.log(from);
    console.log(next);
    if (to.path == "/shopCar") {
      to.meta.index = 70;
    }
    next();
  },

  watch: {
    detailGoback: function (old) {
      if (old == true && this.$route.path == "/type/detail") {
        setTimeout(() => {
          this.reload();
        }, 100);

        this.$store.commit("SET_DETAIL_GOBACK", false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.select-duct {
  font-family: PingFangSC-Regular;
  font-size: 1.4rem;
  color: #424242;
  display: flex;
  div {
    margin-right: 1rem;
  }
}
.quest-box {
  width: 90%;
  background: #f8f8f8;
  margin: 1rem auto;
  padding: 1rem 0;
}
.quest-text {
  text-align: left;
  font-size: 1.4rem;
  width: 90%;
  margin: 1rem auto;
  line-height: 1.6rem;
  white-space: pre-wrap;
  color: #aaaaaa;
}
.quest-bt {
  text-align: center;
  font-size: 1.6rem;
}
.detail-box {
  height: 100%;
  /*控制底部滚动*/
  overflow-y: scroll;
  .my-swipe .van-swipe-item {
    color: #fff;
    text-align: center;
  }
  .swiper-img {
    height: 33rem;
    width: 100%;
  }
  .detail-name {
    width: 95%;
    margin: 1rem auto;
    font-size: 1.6rem;
    text-align: left;
  }
  .price-box {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: 95%;
    margin: 1rem auto;
    font-family: PingFangSC-Medium;
    height: 3rem;
    align-items: flex-end;
    .old-price {
      text-decoration: line-through;
      font-family: PingFangSC-Regular;
      font-size: 1.4rem;
      color: #424242;
      opacity: 0.3;
      letter-spacing: 0;
      line-height: 1.4rem;
    }
    .new-price {
      font-family: PingFangSC-Semibold;
      font-size: 1.4rem;
      color: #f07878;
      letter-spacing: 0.51px;
      margin-left: 1rem;
      line-height: 1.4rem;
    }
  }
  .detail-tag {
    border: 1px solid salmon;
    padding: 0.5rem;
    color: salmon;
    display: inline-block;
    font-size: 1rem;
    border-radius: 5px;
  }
  .add-cart {
    border-top: 1px solid #f4f4f4;
    height: 4rem;
    overflow: hidden;
    font-size: 1.8rem;
    line-height: 3rem;
    text-align: left;
    padding: 0 2.5% 0;
    // border-bottom: 1rem solid #f4f4f4;
    display: flex;
    margin-bottom: 2rem;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .specifications {
      .info-item {
        display: inline-block;
        margin-right: 0.5rem;
      }
    }
  }
  .commodity-parameter {
    padding-bottom: 10rem;
    border-top: 1rem solid #f4f4f4;
    padding-top: 1rem;

    .commodity-title {
      text-align: left;
      padding-left: 1rem;
      font-size: 1.8rem;
      font-weight: 600;
    }
    .com-info {
      width: 100%;
      height: auto;
      /deep/ p {
        width: 100%;
        height: auto;

        img {
          width: 100%;
          height: auto;
        }
      }
    }
    .size {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      width: 95%;
      margin: 1rem auto;
      background: #eee;
      height: auto;
      box-sizing: border-box;
      padding-left: 1rem;
      .size-text {
        color: #998;
        font-size: 1.3rem;
        min-width: 6.5rem;
        text-align: left;
      }
      .size-value {
        color: #000;
        font-size: 1.7rem;
        margin-left: 5rem;
        text-align: left;
      }
    }
  }
}
.item-box {
  width: 100%;
  padding-bottom: 1rem;

  .list {
    width: 100%;
    margin: 0 auto;
  }
}
.select-data {
  padding-left: 1rem;
  text-align: left;
  display: flex;
  flex-direction: row;
  align-items: center;
  .data-item {
    margin-left: 0.5rem;
  }
}
.select-name {
  text-align: left;
  padding-left: 1rem;
  margin: 1rem 0;
}
.select-specifications {
  // display: flex;
  // flex-direction: row;
  // justify-content: flex-start;
  padding-left: 1rem;
  text-align: left;
  // align-items: center;
  .select-item {
    border: 1px solid #999;
    color: #666;
    padding: 0.3rem 1.3rem;
    display: inline-block;
    margin: 0.5rem;
    border-radius: 17px;
  }
  .selected-item {
    border: 1px solid salmon;
    color: salmon;
    padding: 0.3rem 1.3rem;
    display: inline-block;
    margin: 0.5rem;
    border-radius: 17px;
  }
}
.select-num {
  padding-left: 1rem;
  margin: 1rem 0;

  text-align: left;
}
/deep/ .van-stepper {
  text-align: left;
  padding-left: 1rem;
  margin-bottom: 7rem;
}
/deep/ .van-card__content {
  justify-content: center;
  align-items: flex-start;
}
/deep/ .select_icon {
  color: #ff5000;
  .van-icon {
    color: #ff5000;
  }
}
/deep/ .van-goods-action-button--warning {
  background: #555555;
  border-radius: 2em 0px 0px 2em;
}
/deep/ .van-goods-action-button--danger {
  background: #d6be93;
  border-radius: 0px 2em 2em 0px;
}
.comment-title {
  height: 4.65rem;
  display: flex;
  background: #fff;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 1.6rem;
  margin: 1px auto 0;
  box-sizing: border-box;
  border-top: 1rem solid #f4f4f4;

  // border-bottom: 1px solid #999;
  .c-title-text {
    font-family: PingFangSC-Regular;
    font-size: 1.4rem;
    color: #424242;
    letter-spacing: 0;
    line-height: 1.4rem;
    display: flex;
    align-items: center;
    .pinglun {
      width: 2rem;
      height: 2rem;
      margin-right: 0.6rem;
    }
  }
  .insert-text {
    display: flex;
    align-items: center;
    font-family: PingFangSC-Regular;
    font-size: 1.4rem;
    color: #a0a0a0;
    letter-spacing: 0;
    line-height: 1.4rem;
    .input-icon {
      width: 1.6rem;
      height: 1.6rem;
      margin-right: 0.4rem;
    }
  }
}
.item-box {
  width: 100%;
  background: #fff;
  min-height: 3rem;
  height: auto;
  padding: 0 1.6rem 3rem;
  box-sizing: border-box;

  .line {
    opacity: 0.3;
    border-top: 1px solid #c2c2c2;
    width: 100%;
    margin: 0 auto 2.05rem;
  }
  .no-message {
    font-family: PingFangSC-Regular;
    font-size: 1.4rem;
    color: #424242;
    text-align: justify;
    line-height: 1.8rem;
    width: 100%;
    text-align: left;
  }
}

.comment-item {
  height: auto;
  width: 100%;
  margin: 0 auto;
  padding: 1rem 0;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  // justify-content: flex-start;
  border-bottom: 1px solid #eee;
  .comment-item-top {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    .comment-item-name {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      img {
        width: 3.2rem;
        height: 3.2rem;
        border-radius: 100%;
        margin-right: 1rem;
      }
      .item-name {
        font-family: PingFangSC-Semibold;
        font-size: 1.4rem;
        color: #424242;
        line-height: 1.4rem;
      }
      .comment-item-tiem {
        opacity: 0.5;
        font-family: PingFangSC-Regular;
        font-size: 1.2rem;
        color: #424242;
        text-align: right;
        line-height: 1.2rem;
      }
    }
  }
  .comment-item-content {
    width: 100%;
    text-align: left;
    margin-top: 1rem;
    font-family: PingFangSC-Regular;
    font-size: 1.6rem;
    color: #424242;
    line-height: 2rem;
    word-break: break-all;
  }
  .comment-img {
    width: 100%;
    height: auto;
    text-align: left;
    margin-top: 1rem;
    img {
      width: 8rem;
      height: auto;
    }
  }
}
.recommend {
  margin: 1rem 0;
  font-size: 1.6rem;
  color: #999;
}
.special {
  width: 100%;
  background: #fff;
  padding-bottom: 1rem;
  // margin-top: 2rem;
  .special-title {
    width: 100%;
    height: 4rem;
    line-height: 4rem;
    font-size: 1.6em;
    span {
      float: right;
      margin-right: 1rem;
    }
  }
  p {
    width: 96%;
    text-align: left;
    font-size: 1.4rem;
    margin: 0.5rem auto;
  }
  span {
    margin-left: 2rem;
  }
  img {
    width: 96%;
  }
  .special-sub {
    color: orange;
    font-size: 1.4rem;
  }
}
.more {
  margin: 1rem 0;
  font-size: 1.4rem;
}
.close-popup {
  position: absolute;
  right: 0;
  top: 0;
}
/deep/ .van-grid-item__content--center {
  padding: 0;
  height: 8rem;
  overflow: hidden;
}
/deep/ .van-icon__image {
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/type/detail.vue